export default "__VITE_ASSET__DTI7zD0O__"